import { useEffect, useRef } from "react";
import mesimoLogoMark from "../../../assets/logo/logo.jpg";
import heroBg from "../../../assets/readdy/hero-bg.jpg";

export default function Hero() {
  const textRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const words = ["Software", "Web Apps", "Mobile Apps", "Cloud Solutions"];
    let i = 0;
    let charIdx = 0;
    let deleting = false;
    let timeout: ReturnType<typeof setTimeout>;

    const type = () => {
      const word = words[i];
      if (!textRef.current) return;
      if (!deleting) {
        textRef.current.textContent = word.slice(0, charIdx + 1);
        charIdx++;
        if (charIdx === word.length) {
          deleting = true;
          timeout = setTimeout(type, 1800);
        } else {
          timeout = setTimeout(type, 100);
        }
      } else {
        textRef.current.textContent = word.slice(0, charIdx - 1);
        charIdx--;
        if (charIdx === 0) {
          deleting = false;
          i = (i + 1) % words.length;
          timeout = setTimeout(type, 400);
        } else {
          timeout = setTimeout(type, 60);
        }
      }
    };
    timeout = setTimeout(type, 600);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <section
      id="hero"
      className="relative min-h-screen flex flex-col items-center overflow-hidden"
      style={{ background: "linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 60%, #111 100%)" }}
    >
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src={heroBg}
          alt="Mesimo Inc. hero background"
          className="w-full h-full object-cover object-center opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>



      {/* Main headline */}
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto w-full mt-32 mb-10">
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-[1.05] tracking-tight mb-6">
          Mesimo Inc. —<br />
          We Build{" "}
          <span className="italic font-light text-white/60">
            <span ref={textRef}>Software</span>
            <span className="animate-pulse">|</span>
          </span>
        </h1>
        <p className="text-white/50 text-sm font-medium tracking-widest uppercase mb-3">
          Turning Ideas Into Digital Reality
        </p>
        <p className="text-white/60 text-lg md:text-xl max-w-xl mx-auto leading-relaxed mb-12">
          A tech company based in Takoradi, Ghana — crafting world-class software products, web applications, and digital solutions for businesses that want to grow fast and scale smart.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => document.getElementById("work")?.scrollIntoView({ behavior: "smooth" })}
            className="bg-white text-black font-semibold text-sm px-8 py-4 rounded-full hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap"
          >
            See Our Work
          </button>
          <button
            onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
            className="border border-white/30 text-white font-medium text-sm px-8 py-4 rounded-full hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
          >
            Start a Project
          </button>
        </div>
      </div>

      {/* Rotating badge */}
      {/*
      <div
        className="absolute z-20 bottom-28 right-[12%] md:right-[15%] w-32 h-32 cursor-pointer group"
        onClick={() => document.getElementById("work")?.scrollIntoView({ behavior: "smooth" })}
      >
        <svg
          viewBox="0 0 120 120"
          className="w-full h-full animate-[spin_12s_linear_infinite]"
        >
          <defs>
            <path
              id="circlePath"
              d="M 60,60 m -42,0 a 42,42 0 1,1 84,0 a 42,42 0 1,1 -84,0"
            />
          </defs>
          <textPath
            href="#circlePath"
            style={{ fontSize: "10px", fill: "rgba(255,255,255,0.7)", fontFamily: "inherit", letterSpacing: "0.22em" }}
          >
            Case Study &bull; Case Study &bull; Case Study &bull;
          </textPath>
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-14 h-14 rounded-full bg-white/15 backdrop-blur-sm border border-white/25 flex items-center justify-center group-hover:bg-white/25 transition-all group-hover:scale-110">
            <i className="ri-arrow-right-up-line text-white text-2xl -rotate-[15deg]"></i>
          </div>
        </div>
      </div>
      */}

      {/* Stats row */}
      <div className="relative z-10 mt-auto mb-14 w-full max-w-4xl mx-auto px-6">
        <div className="grid grid-cols-1 gap-6 border-t border-white/10 pt-10 md:grid-cols-1">
          {[
            { num: "2026", label: "Founded" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white">{stat.num}</div>
              <div className="text-white/40 text-sm mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

    </section>
  );
}
